import React from 'react';
import { MessageCircle, Send } from 'lucide-react';
import { businessInfo } from '../../data/mock';

export const FloatingWhatsApp = () => {
  return (
    <div className="fixed bottom-6 right-6 z-50 flex flex-col gap-3">
      {/* Telegram Button */}
      <a
        href={businessInfo.telegramLink}
        target="_blank"
        rel="noopener noreferrer"
        className="group"
        aria-label="Chat via Telegram"
      >
        <div className="relative">
          {/* Button */}
          <div className="relative w-14 h-14 bg-[#0088cc] hover:bg-[#006699] flex items-center justify-center rounded-full shadow-lg shadow-[#0088cc]/30 transition-all duration-300 group-hover:scale-110">
            <Send className="w-6 h-6 text-white" />
          </div>

          {/* Tooltip */}
          <div className="absolute bottom-full right-0 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            <div className="bg-white text-black text-sm font-medium px-4 py-2 rounded-lg shadow-lg whitespace-nowrap">
              Telegram @NozenMods
              <div className="absolute top-full right-4 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-white" />
            </div>
          </div>
        </div>
      </a>

      {/* WhatsApp Button */}
      <a
        href={businessInfo.whatsappLink}
        target="_blank"
        rel="noopener noreferrer"
        className="group"
        aria-label="Chat via WhatsApp"
      >
        <div className="relative">
          {/* Pulse Animation */}
          <div className="absolute inset-0 bg-[#25D366] rounded-full animate-ping opacity-30" />
          
          {/* Button */}
          <div className="relative w-14 h-14 bg-[#25D366] hover:bg-[#20BD5C] flex items-center justify-center rounded-full shadow-lg shadow-[#25D366]/30 transition-all duration-300 group-hover:scale-110">
            <MessageCircle className="w-7 h-7 text-white" />
          </div>

          {/* Tooltip */}
          <div className="absolute bottom-full right-0 mb-3 opacity-0 group-hover:opacity-100 transition-opacity duration-300 pointer-events-none">
            <div className="bg-white text-black text-sm font-medium px-4 py-2 rounded-lg shadow-lg whitespace-nowrap">
              Chat WhatsApp
              <div className="absolute top-full right-4 w-0 h-0 border-l-8 border-r-8 border-t-8 border-transparent border-t-white" />
            </div>
          </div>
        </div>
      </a>
    </div>
  );
};
